module.exports = __webpack_public_path__ + "assets/img/277f36b0771ca1c055256611904742ec.svg";